var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex-col items-center"},[_c('h1',{staticClass:"text-gray-700 text-6xl"},[_vm._v("Error")]),_c('router-link',{staticClass:"mt-5 text-xl text-green-600 hover:underline",attrs:{"to":"/"}},[_vm._v(" Volver al inicio ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }